// @flow
import React, { useCallback } from 'react';
import classNames from 'classnames';
import prop from 'ramda/es/prop';
import find from 'ramda/es/find';
import head from 'ramda/es/head';

import RadioButton, { RadioButtonGroup } from 'app/common/ui/RadioButton';
import { DotsLoader } from 'app/common/components/Loader';

import styles from './RadioFilterComplete.module.scss';;


const emptyArray = [];
const addId = (id: string, key: string) => (`${id}_${key}`);
const removeId = (value: string, id: string) => value.replace(new RegExp(`^${id}_`), '');

type Props = {
  id: string,
  title?: string,
  loading?: boolean,
  className?: string,

  itemsArray?: Array<{ id: string, title: string }>,
  selectedArr: [string],
  onChange?: ({ id: string, value: Array<string> }) => void,
}

const RadioFilterComplete = ({
  id,
  title,
  loading,
  className,

  itemsArray = emptyArray,
  selectedArr,
  onChange,
}: Props) => {
  const selected = addId(id, head(selectedArr));

  // переключение
  const handleChange = useCallback((e) => {
    const { value: valueWithId, checked } = e.currentTarget;
    const value = removeId(valueWithId, id);
    const selectedItemId = prop('id', find(({ id: key }) => key === value, itemsArray) || {});
    if (!selectedItemId) return;
    if (checked && typeof onChange === 'function') {
      onChange({ id, value: [selectedItemId] });
    }
  }, [itemsArray, onChange, id]);

  // процесс loading === true
  if (loading) {
    return (
      <div className={classNames(styles.root, className)}>
        <div className={styles.label}>
          {title}
          &nbsp;&nbsp;&nbsp;
          <DotsLoader simple />
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.label}>
        {title}
      </div>
      <RadioButtonGroup
        id={id}
        name={id}
        valueSelected={selected}
        onChange={handleChange}
      >
        {itemsArray.map(({ id: key, title: label }) => (
          <RadioButton
            key={key}
            label={label}
            value={addId(id, key)}
          />
        ))}
      </RadioButtonGroup>
    </div>
  );
};

export default RadioFilterComplete;
